import axios from 'axios';

const service = axios.create();

service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('userToken') || localStorage.getItem('user-token');
    if (token) {
      config.headers['Authorization'] = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
    }
    const currentWorkUnitId = localStorage.getItem('currentWorkUnitId');
    if (currentWorkUnitId && !config.headers['X-WorkUnit-Id'] && !config.headers['X-Workunit-Id']) {
      config.headers['X-WorkUnit-Id'] = currentWorkUnitId;
      config.headers['X-Workunit-Id'] = currentWorkUnitId;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

service.interceptors.response.use((response) => response.data, (error) => Promise.reject(error));

export default service;
